import React from 'react'
import { Fab } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { mainGreen } from '../../utils/color'

const styles = {
	fab: {
		position: 'fixed',
		bottom: '20px',
		right: '20px',
		backgroundColor: mainGreen,
		color: 'white',
	},
}

export default function ButtonCreate(props) {
	const { onClick } = props
	return (
		<Fab sx={styles.fab} onClick={onClick}>
			<AddIcon />
		</Fab>
	)
}

